module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-skills-single-projects"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.case_number) + "\n                    ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                            content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                        }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7100ece"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/learning/components/employeeSkillsSingleProjects.vue
// module id = 920
// module chunks = 0